<template>
  <div class="sched-form-wrap">
    <div class="modal-header">
      <h1 class="page-title">{{ t('print_title_modal') }}</h1>
      <!-- BACK -->
      <button
        @click="cancelListener"
        type="button"
        class="btn btn-icon btn-dark btn-close"
        aria-label="Close">
        <i class="icon wb-close"></i>
      </button>

      <!-- SUBMIT -->
      <button
        @click="submitListener"
        class="btn btn-icon btn-success float-right"
        type="button">
        <i class="icon wb-check"></i>
      </button>
    </div>
    <form v-on:keyup.enter="submitListener">
      <div class="row form">
        <div class="col-md-12 form-row">
          <label>
            {{ t('send_form_email') }}
          </label>
          <input v-model="email" class="form-control">
        </div>
      </div>

    </form>

  </div>
</template>

<script>
import InputBox from '../forms/elements/InputBox'
import Button   from '../grids/renderers/grid-form/elements/button'
import Swal     from 'sweetalert2/dist/sweetalert2.js'

export default {
  name:       'send-print-form',
  components: { Button, InputBox },
  props:      ['resource', 'buttonDef', 'data'],
  data () {
    return {
      email: null
    }
  },

  created () {
    this.email = this.data && this.data.hasOwnProperty('MF_SENDMAIL_TO') ? this.data.MF_SENDMAIL_TO : null
  },

  methods: {
    submitListener () {
      this.data['MF_SENDMAIL_TO'] = this.email
      this.data['MF_SENDMAIL']    = 1

      let args = {
        ruleType: 'Action',
        ruleName: this.buttonDef.ViewName,
        where:    '',
        value:    this.data
      }

      this
        .resource
        .setDef(this.def)
        .callReport(args)
        .then((response) => {
          let icon    = 'success',
              title   = this.$translate.text('send_report_ok'),
              message = response.data ? response.data.message : null

          if (!message) {
            this.$modal.hide('send-modal')
            return
          }

          if (response.status !== 200 || response.status !== 201 || response.status !== 204) {
            icon  = 'error'
            title = this.$translate.text('send_report_error')
          }

          Swal
            .fire({
              icon:              icon,
              title:             title,
              text:              message,
              showCancelButton:  false,
              showConfirmButton: false,
              timer:             3000
            })
            .then((result) => {
              if (result.value
                && result.value === true
                && callback instanceof Function) {
                callback()
              }
            })
        }).catch((error) => {
        this.$modal.hide('send-modal')
        this.handleApiError(error)
      })
    },

    cancelListener () {
      this.$emit('cancel', this.eventValueObject)

      this.$modal.hide('send-modal')
    }
  }
}
</script>

<style scoped>
.form-row {
  margin: 5px 0;
}

.sched-form-wrap {
  margin: 20px;
}

.modal-header {
  padding: 0;
  margin-bottom: 0;
  justify-content: flex-end;
}

.modal-header .btn-success {
  margin: 0;
}

.modal-header button {
  margin-right: 3px;
}

</style>
